import { KeyValueString } from "../types";

export const gqlApis: KeyValueString = {
  testnet: 'https://www.routerexplorer.com/gql/testnet',
  devnet: 'https://www.routerexplorer.com/gql/devnet',
  local: 'http://127.0.0.1:3000/gql/query',
};

export * from './CrosschainEvents';
//console.log(`Constants.ts empty right now`);
